module.exports = __webpack_public_path__ + "mainassets/img/info2.0167fd33.svg";